import { Card, Label } from "@osago/ui";
import { PARAM_DOCS, RESERVED_UTM_SOURCE, type ParamDoc } from "@/shared/config/referral";

const PLACE_LABEL: Record<ParamDoc["place"], string> = {
  hash: "после #",
  query: "query",
  path: "путь",
};

const PLACE_CLASS: Record<ParamDoc["place"], string> = {
  hash: "bg-error-soft text-error-accent",
  query: "bg-brand-soft text-brand",
  path: "bg-canvas text-label-text",
};

export function ParamsReference() {
  return (
    <Card padding="lg">
      <Label variant="section" as="h3" className="mb-3">
        Справочник параметров ссылки
      </Label>
      <div className="overflow-x-auto">
        <table className="w-full min-w-140 border-collapse text-left">
          <thead>
            <tr className="border-b border-input-border">
              <th className="py-2 pr-3">
                <Label variant="caption">Параметр</Label>
              </th>
              <th className="py-2 pr-3">
                <Label variant="caption">Часть ссылки</Label>
              </th>
              <th className="py-2 pr-3">
                <Label variant="caption">Назначение</Label>
              </th>
              <th className="py-2">
                <Label variant="caption">Пример</Label>
              </th>
            </tr>
          </thead>
          <tbody>
            {PARAM_DOCS.map((doc) => (
              <tr key={doc.param} className="border-b border-input-border last:border-b-0">
                <td className="py-2.5 pr-3 align-top">
                  <code className="font-mono text-xs text-input-text">{doc.param}</code>
                </td>
                <td className="py-2.5 pr-3 align-top">
                  <span
                    className={`inline-block rounded-full px-2 py-0.5 text-xs whitespace-nowrap ${PLACE_CLASS[doc.place]}`}
                  >
                    {PLACE_LABEL[doc.place]}
                  </span>
                </td>
                <td className="py-2.5 pr-3 align-top">
                  <Label variant="hint" className="block">
                    {doc.purpose}
                  </Label>
                </td>
                <td className="py-2.5 align-top">
                  <code className="font-mono text-xs break-all text-label-text">{doc.example}</code>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Label variant="hint" className="mt-3 block">
        Параметры после # считываются трекером партнёрской программы в браузере и сохраняются в
        cookie — атрибуция работает, даже если клиент вернётся и оформит полис позже. Значение
        utm_source={RESERVED_UTM_SOURCE} зарезервировано под режим виджета — в реферальных ссылках
        его использовать нельзя.
      </Label>
    </Card>
  );
}
